import React, { useEffect, useContext, useState } from 'react'
import { Switch, useParams, useRouteMatch } from 'react-router-dom'
import AdminRoute from './AccountRoute'
import Settings from '../../settings/_root/components/index'
import * as accountApi from '../../../modules/account/services/api'
import { selectPartner } from '../../../global/partner/store/actions'
import { Partner } from '../../../global/partner/store/store'
import { AppContext } from '../../../global/index'
import { CrumbInfo } from '../../../components/Breadcrumb'

type Params = {
  accountId: string
}

type State = {
  settings: CrumbInfo[]
}

function AdminRoutes() {
  const { accountId } = useParams() as Params
  const { path } = useRouteMatch()
  const { state, execute } = useContext(AppContext)
  const [localState, setLocalState] = useState({} as State)

  async function setSelectedPartner(accountId: string) {
    const res = await accountApi.getAccount(accountId)
    const selectedPartner = state.auth.partners.find(p => p.id === res.data.subscription.data.reseller.data.id)

    const accountBreadcrumbInfo = {
      url: `/account/${accountId}`,
      text: res.data.name,
      enabled: false
    }

    setLocalState({
        settings: [accountBreadcrumbInfo]
    })

    if (selectPartner) {
      execute(selectPartner(selectedPartner as Partner))
    }
  }

  useEffect(() => {
    if (accountId) {
      setSelectedPartner(accountId)
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accountId])

  return (
    <Switch>
      <AdminRoute path={`${path}/settings`} breadcrumbInfo={localState.settings} component={Settings} />
    </Switch>
  )
}

export default AdminRoutes
